<template>
  <div class="bind bg-[#dedede]">
    <div class=" mx-5">
      <p class="text-lg mb-5 text-[#5c5c5c]">您好，請先完成綁定</p>
      <div class="text-md bg-[#ffffff] rounded-lg p-5 shadow-lg">
        <p class="text-left mb-2">姓名</p>
        <input type="text" class="w-full input-frame p-2 mb-5" v-model="name" placeholder="請輸入姓名">
        <input type="text"  class="w-full input-frame p-2  mb-5" v-model="mobile" placeholder="請輸入手機號碼">
        <div class="w-full input-frame py-1 px-2 bg-white flex justify-between items-center mb-5">
          <input type="text" class="w-full outline-none" v-model="captcha" maxlength="6" placeholder="請輸入手機驗證碼">
          <button class="text-nowrap bg-[#f08c00] text-white px-3 py-1 rounded-lg" @click="sendOTP()">獲取驗證碼</button>
        </div>
        <button class="text-nowrap bg-[#f08c00] text-white px-3 py-2 rounded-full w-full" @click="submit()">送 出</button>
      </div>
    </div>
  </div>
  <div class="modal z-[101]" :style="{ height: windowHeight }" v-if="msgModel || bindModel">
    <div class="modal-content shadow p-5 text-[#868686]" v-if="msgModel">
      <p class="my-3">{{ msg }}</p>
      <div class="flex items-center justify-center text-white">
        <button class="rounded-full bg-[#f08c00]  py-2 w-1/3 cursor-pointer" @click="msgModel = false">確認</button>
      </div>
    </div>
    <div class="modal-content shadow p-5 text-[#868686]" v-if="bindModel">
      <p class="my-3">{{ msg }}</p>
      <div class="flex items-center justify-center text-white">
        <button class="rounded-full bg-[#606060]  py-2 w-1/3 cursor-pointer mr-3" @click="bindModel = false">取消</button>
        <button class="rounded-full bg-[#f08c00]  py-2 w-1/3 cursor-pointer" @click="bind()">合併</button>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import axios from 'axios'
// import CryptoJS from 'crypto-js'
// import axios from 'axios'
// import liff from '@line/liff'
// import api from '@/service/api'
// const apiBaseUrl = process.env.VUE_APP_API_BASE
export default {
  name: 'LoginView',
  components: {
    // HelloWorld
  },
  data () {
    return {
      channelId: '',
      mobile: '',
      captcha: '',
      name: '',
      msgModel: false,
      bindModel: false,
      msg: '',
      windowHeight: window.innerHeight,
      onceToken: '',
      apToken: ''
    }
  },
  created () {
    this.source = this.$route.query.source
    this.channelId = localStorage.getItem('userId') || ''
    this.name = localStorage.getItem('displayName') || ''
    this.login()
  },
  async mounted () {
    window.addEventListener('resize', this.handleResize)
  },
  methods: {
    closeMsgModel () {
      this.msgModel = false
    },
    handleResize () {
      this.windowHeight = window.innerHeight
    },
    bind () {
      this.msgModel = false
      this.bindModel = false
      axios({
        method: 'post',
        url: `${process.env.VUE_APP_API_BASE_URL}admin/v1/user/bind/info`,
        data: {
          joinConfirm: 1,
          name: this.name,
          phone: this.mobile,
          countryCode: '+886'
        },
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          aptoken: this.apToken
        },
        withCredentials: true
      }).then((response) => {
        if (response.data.code === 1000) {
          this.$router.replace({ name: this.source })
        } else {
          this.msgModel = true
          this.msg = response.message
        }
      }).catch((error) => {
        console.error('API 錯誤:', error)
      })
    },
    submit () {
      if (this.name === '' || this.mobile === '' || this.captcha === '') {
        this.msgModel = true
        this.msg = '請輸入完整資訊'
        return
      }
      axios({
        method: 'post',
        url: `${process.env.VUE_APP_API_BASE_URL}job/otp/validate`,
        data: {
          onceToken: this.onceToken,
          code: this.captcha,
          phoneNumber: this.mobile
        }
      }).then((response) => {
        if (response.data.data === true) {
          axios({
            method: 'post',
            url: `${process.env.VUE_APP_API_BASE_URL}admin/v1/user/bind/info`,
            data: {
              joinConfirm: 0,
              name: this.name,
              phone: this.mobile,
              countryCode: '+886'
            },
            headers: {
              'Content-Type': 'application/json; charset=utf-8',
              aptoken: this.apToken
            },
            withCredentials: true
          }).then((response2) => {
            if (response2.data.code === 1000) {
              if (response2.data.data === -1) {
                this.bindModel = true
                this.msg = '該手機號碼已存在點鑽生態中，合併後將將重新綁定，是否合併?'
              } else {
                this.$router.replace({ name: 'box' })
              }
            } else {
              this.msgModel = true
              this.msg = response2.data.message
            }
          }).catch((error) => {
            console.error('API 錯誤:', error)
          })
        } else {
          this.msgModel = true
          this.msg = response.data.message
        }
      }).catch((error) => {
        console.error('API 錯誤:', error)
      })
    },
    sendOTP () {
      const regex = /^09\d{8}$/
      if (!regex.test(String(this.mobile))) {
        this.msgModel = true
        this.msg = '請輸入正確的手機號碼'
        return
      }
      axios({
        method: 'post',
        url: `${process.env.VUE_APP_API_BASE_URL}job/otp/send`,
        data: {
          countryCode: '+886',
          mobile: this.mobile
        }
      }).then((response) => {
        if (response.data.code === 1000) {
          this.onceToken = response.data.data.onceToken
          this.msgModel = true
          if (response.data.data.io === '1') {
            this.msg = 'OTP驗證碼有效期限為一天，請查找手機訊息確認'
          } else {
            this.msg = 'OTP驗證碼已發送'
          }
        } else {
          this.msgModel = true
          this.msg = response.message
        }
      }).catch((error) => {
        console.error('API 錯誤:', error)
      })
    },
    async login () {
      await axios({
        method: 'post',
        url: `${process.env.VUE_APP_API_BASE_URL}auth/login`,
        data: {
          loginType: 1,
          channel: 'lineId',
          channelId: this.channelId,
          tenantId: process.env.VUE_APP_TENANT_ID,
          name: this.name
        }
      }).then((response) => {
        this.apToken = response.data.data.tokenData.tokenValue
      }).catch((error) => {
        console.error('API 錯誤:', error)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.bind{
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.input-frame{
  background: #ebebeb;
  // border: 1px solid #898989;
  outline: none;
  border-radius: 8px;
  input{
    background: transparent;
  }
}
.modal{
    width: 100%;
    height: 100vh;
    background: rgba(0,0,0,0.5);
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    .modal-content{
      max-width: 450px;
      background: #ffffff;
      width: 90%;
      border-radius: 12px;
      margin: auto;
    }
  }
@media only screen and (min-width: 768px) {
}
</style>
